import React, {useEffect} from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import Checkbox from "../../Checkbox";

function SingleCheckbox(props) {
    const {survey: {answers}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] || "";

    useEffect(() => {
        if(!answer) {
            setAnswer(props.question.id, "");
        }
    }, []);

    const isShown = props.question.part === props.activePart;
    const handleChange = () => {
            setAnswer(props.question.id, answer === "checked" ? "" : "checked")
    }

    return (
        <div className={isShown ? "" : "hidden"}>
            <Checkbox checked={answer === "checked"}
                      value="checked"
                      handleCheckboxChange={handleChange}>
                <div className="text-lg text-grey-darker leading-tight">
                    {props.question.questionText}
                </div>
            </Checkbox>
            {props.question.infoWhenChecked && answer === "checked" &&
            <div className="mt-1">
                {props.question.infoWhenChecked}
            </div>
            }
        </div>
    );
}

export default SingleCheckbox;